/**
 * Cart Selectors
 */
import type { Cart, CartState } from "../../types/cart.types";

export const getCartData = (state: CartState): Cart => {
	return state.cartData;
};

export const getCartItems = (state: CartState) => {
	return state.cartData.items;
};

export const getCartItemsCount = (state: CartState): number => {
	return state.cartData.itemsCount;
};

export const getCartTotal = (state: CartState): number => {
	return state.cartData.total;
};

export const getFormattedTotal = (state: CartState): string => {
	return state.cartData.formattedTotal;
};

export const getFormattedSubtotal = (state: CartState): string => {
	return state.cartData.formattedSubtotal;
};

export const isCartLoading = (state: CartState): boolean => {
	return state.isLoading;
};

export const isCartLoaded = (state: CartState): boolean => {
	return state.isLoaded;
};

export const isCartUpdating = (state: CartState): boolean => {
	return (
		state.itemsPendingDelete.length > 0 ||
		state.itemsPendingQuantity.length > 0
	);
};

export const isCartEmpty = (state: CartState): boolean => {
	return state.cartData.items.length === 0;
};

export const getCartError = (state: CartState): null | string => {
	return state.error;
};

export const isItemPendingDelete = (
	state: CartState,
	itemId: number,
): boolean => {
	return state.itemsPendingDelete.includes(itemId);
};

export const isItemPendingQuantity = (
	state: CartState,
	itemId: number,
): boolean => {
	return state.itemsPendingQuantity.includes(itemId);
};

export const getCartWarnings = (state: CartState): string[] => {
	return state.warnings;
};
